import { Box, Grid } from '@factorialco/deprecated-design-system'

interface Props {
  sidebar?: React.ReactNode
}

export const SectionComponentLayout = ({ sidebar, children }: React.PropsWithChildren<Props>) => {
  return (
    <Grid variant="fixed">
      <Box gridColSpan={{ xs: 9 }}>{children}</Box>
      {sidebar && (
        <Box gridColSpan={{ xs: 3, s: 3 }} gap="s16">
          {sidebar}
        </Box>
      )}
    </Grid>
  )
}
